import React, { Fragment } from "react";
import Cleave from "cleave.js/react";
import { bool, string, number, func, oneOfType } from "prop-types";
import { isString } from "validate.js";
import { decimalTohhmm } from "../../helpers/helpers";

import * as style from "./styles.module.scss";
import Checkbox from "../../common/Checkbox/index";

const hhmmToDecimal = (time) => {
  if (time === "") {
    return 0;
  }
  const [hours, minutes] = time.split(":").map((str) => parseInt(str, 10));
  return hours + minutes / 60;
};

const decimalTohh = (time) => {
  if (isString(time)) {
    return time.split(":")[0];
  }
  if (time === "") {
    return 0;
  }
  let hours = Math.floor(time);

  if (hours < 10) {
    hours = `0${hours}`;
  }

  return hours;
};

const decimalTomm = (time) => {
  if (isString(time)) {
    return time.split(":")[1];
  }
  if (!time) {
    return "00";
  }

  let minutes = 60 * (time - Math.floor(time));
  const splitMinutes = String(minutes).split(".");
  if (splitMinutes[1] && splitMinutes[1].substr(0, 2) === "99") {
    minutes = Math.floor(minutes) + 1;
  }
  if (minutes < 10) {
    return `0${Math.floor(minutes)}`;
  }

  return Math.floor(minutes);
};

const TimesheetCell = ({
  isEditing = true,
  hours,
  handleChange,
  bookedDay,
  nonAttendanceCode,
  error,
  cellType = "H",
}) => {
  if (!bookedDay || nonAttendanceCode !== null) {
    return null;
  }

  const inputTime = {
    hours: decimalTohh(hours),
    minutes: decimalTomm(hours),
  };

  const updateHours = (value, type) => {
    const newTime = { ...inputTime, [type]: value };
    handleChange(hhmmToDecimal(`${newTime.hours}:${newTime.minutes}`));
  };

  const errorClass = error ? style.errorOutline : "";

  const getCellInternals = (type) => {
    switch (type) {
      case "H":
        return (
          <div className={style.timesheetCell__inputs}>
            <label>
              Hours
              <Cleave
                className={errorClass}
                options={{ time: true, timePattern: ["hh"] }}
                type="text"
                value={decimalTohh(hours)}
                size="2"
                onBlur={(e) => {
                  updateHours(
                    e.target.value === "" ? 0 : e.target.value,
                    "hours"
                  );
                }}
              />
            </label>
            <label>
              Mins
              <Cleave
                className={errorClass}
                options={{ time: true, timePattern: ["mm"] }}
                type="text"
                size="2"
                value={decimalTomm(hours)}
                onBlur={(e) => {
                  updateHours(
                    e.target.value === "" ? 0 : e.target.value,
                    "minutes"
                  );
                }}
              />
            </label>
          </div>
        );

      case "D":
        return (
          <Fragment>
            <div
              className={`w-100 d-flex justify-content-center align-items-center`}
            >
              <Checkbox
                classes={style.timesheetCell__checkbox}
                isChecked={hours === 1}
                onClick={() => updateHours(hours === 1 ? 0 : 1, "hours")}
              />
            </div>
          </Fragment>
        );

      default:
        return <Fragment></Fragment>;
    }
  };

  return isEditing ? (
    <Fragment>{getCellInternals(cellType)}</Fragment>
  ) : (
    <div className={style.timesheetCell__hours}>
      {decimalTohhmm(hours) && cellType === "D" ? (
        <svg
          width="78"
          height="32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="31"
            y="1"
            width="30"
            height="30"
            rx="15"
            fill="#0EAD0E"
            fillOpacity=".05"
            stroke="#0EAD0E"
            strokeWidth="2"
          />
          <path
            d="M42.717 20.258l-4.269-4.041L37 17.587 42.717 23 55 11.371 53.552 10 42.717 20.258z"
            fill="#0EAD0E"
          />
        </svg>
      ) : (
        decimalTohhmm(hours)
      )}
    </div>
  );
};

TimesheetCell.propTypes = {
  isEditing: bool.isRequired,
  hours: oneOfType([string, number]).isRequired,
  handleChange: func.isRequired,
  bookedDay: bool.isRequired,
  nonAttendanceCode: string.isRequired,
  error: bool,
  cellType: string,
};

export default TimesheetCell;
